import { Team } from 'modules/teams/domain/interfaces/team';
import { useDispatch } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import EditTeam from '../components/edit-team';
import TeamsComponentsFormParticipantsListPart from '../components/form-parts/participants/participants-list';

import CreatePlayer from '../components/form-parts/players/create-player';
import TeamsComponentsFormPlayersListPart from '../components/form-parts/players/players-list';
import WaitingList from '../components/form-parts/waiting-list/waiting-list';
import { useAuth } from 'modules/auth/ui/hooks/use-auth';
import { toast } from 'react-toastify';
import { usePlayers } from 'modules/organizer/ui/hooks/use-players';
import { useEntryRequests } from 'modules/teams/ui/hooks/use-entry-requests';
import { getTeamPlayers } from 'modules/teams/store/players/actions';
import { useEffect } from 'react';

type Props = {
  team: Team;
  isLoading?: boolean;
};

const TeamComponentsEditForm = (props: Props) => {
  const dispatch = useDispatch();
  const { userTournamentId } = useAuth();

  const { team, isLoading } = props;

  useEffect(() => {
    if (team?.id) {
      dispatch(getTeamPlayers(team?.id));
    }
  }, [dispatch, team]);

  const { info: players, isGettingPlayers } = usePlayers();
  const { entryRequests, isLoading: isLoadingEntryRequests } = useEntryRequests(team.id);

  if (isLoading || (isGettingPlayers && players.length === 0) || isLoadingEntryRequests) {
    return (
      <div className="d-flex gap-12">
        <div className="skeleton-block" style={{ width: 502, height: 67 }} />
        <div className="skeleton-block" style={{ width: 502, height: 348 }} />
      </div>
    );
  }

  if (!userTournamentId) {
    toast.error('Не удалось определить активный турнир, перезагрузите страницу');
    return null;
  }

  return (
    <Routes>
      <Route
        path="players"
        element={<TeamsComponentsFormPlayersListPart teamId={team.id} players={team.players.filter((player) => !player.isReal)} />}
      />
      <Route path="players/create" element={<CreatePlayer tournamentId={userTournamentId} teamId={team.id} />} />
      <Route
        path="participants"
        element={<TeamsComponentsFormParticipantsListPart teamId={team.id} participants={players.filter((player) => player.isReal)} />}
      />
      <Route
        path="waiting-list"
        element={<WaitingList entryRequests={entryRequests.filter((entryRequest) => entryRequest.status === 'CREATED')} />}
      />
      <Route path="*" element={<EditTeam team={team} tournamentId={userTournamentId} />} />
    </Routes>
  );
};

export default TeamComponentsEditForm;
